import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9741413e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  viewBox: "0 0 120 120",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "47.8373",
    y: "46.882",
    width: "20.9619",
    height: "31.25",
    rx: "2.75",
    fill: "#EB6C4B",
    stroke: "white",
    "stroke-width": "1.5"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "68",
  cy: "52",
  r: "10.75",
  fill: "#EB6C4B",
  stroke: "white",
  "stroke-width": "1.5"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M64 51.7391L66.8169 55L72 49",
  stroke: "white",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}